import { Icon } from '@types';

export const Phone = ({ customStyles, handleClick }: Icon) => {
	return (
		<svg
			onClick={handleClick}
			className={customStyles}
			id="Layer_1"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 75.88 75.88"
		>
			<defs>
				<style>
					{
						'.cls-call{fill:none;stroke:#2e2d2c;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}'
					}
				</style>
			</defs>
			<g>
				<path className="cls-call" d="M36.42,20.15c10.66,0,19.3,8.64,19.3,19.3" />
				<path className="cls-call" d="M36.43,10.58c15.95,0,28.88,12.93,28.88,28.88" />
				<path className="cls-call" d="M36.42,1c21.24,0,38.46,17.22,38.46,38.46" />
			</g>
			<path
				className="cls-call"
				d="M5.54,11.55h0C-3.82,20.91,1.75,41.65,17.99,57.89c16.23,16.23,36.98,21.81,46.34,12.45,2.84-2.84,4.13-9.28,4.13-9.28,.21-1.06-.4-2.24-1.37-2.63l-16.99-6.79c-.97-.39-2.4-.06-3.18,.72l-4.92,4.92c-.94,.94-2.3,1.17-3.37,.69-.09-.04-.17-.09-.25-.13-.04-.02-.07-.04-.11-.06-3.74-2.04-7.7-5.01-11.43-8.73-3.73-3.72-6.69-7.68-8.73-11.42-.02-.04-.04-.07-.06-.1-.05-.09-.09-.17-.13-.26-.48-1.07-.25-2.43,.69-3.37l4.93-4.93c.78-.78,1.11-2.21,.72-3.18l-6.79-16.99c-.39-.97-1.57-1.58-2.63-1.37,0,0-6.44,1.29-9.28,4.12Z"
			/>
		</svg>
	);
};
